import { decode, encode } from '@/utils/modules/base64'

// 是否使用加密
const useEncode = false

const storage = {

  clear () {
    sessionStorage.clear()
  },

  setItem (key, value) {
    if (useEncode) {
      value = encode(value)
    }
    sessionStorage.setItem(key, value)
  },

  getItem (key) {
    let value = sessionStorage.getItem(key)
    if (useEncode) {
      value = decode(value)
    }
    return value
  },

  removeItem (key) {
    sessionStorage.removeItem(key)
  }
}

export default storage
